import React, { Component } from 'react';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { deleteNumber } from '../../../Images/GenericSVG'
import { validateOnlyNumbers } from '../../../js/helpers/Utils/Validations';
import { animationCircle } from '../../../js/animations';
import { phoneIcon, cellICon } from '../../../Images/ManualCallSVG';
import { UncontrolledTooltip } from 'reactstrap';

export default class Keyboard extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.keyboard = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];
  }

  componentDidUpdate(nextProps) {
    if (nextProps.onFocus) {
      this.focusTel();
      this.sharedData.setFocusTel(false);
    }
  }

  onCreateAnimation(e) {
    animationCircle(e.nativeEvent.layerX - 1, e.nativeEvent.layerY - 1, e.currentTarget, this.refs["pruebaRender"])
  }

  addingNewNumber(e) {
    if (e.key === 'Enter') {
      if (this.props.onEnter) {
        this.props.onEnter();
      }
    } else {
      validateOnlyNumbers(e);
      let parent = this.refs["key-" + e.key];
      if (parent) {
        animationCircle(parent.clientWidth / 2.0, parent.clientHeight / 2.0, parent, this.refs["pruebaRender"]);
      }
    }
  }

  focusTel() {
    this.refs["inputTelephone"].focus();
  }
  blurTel() {
    this.refs["inputTelephone"].blur();
  }

  render() {
    return (
      <div className="keyboardContainer">
        <div className="buttonAnimation hidden" ref="pruebaRender"></div>
        <div className='numberContainerArea '>
        <div className={`numberContainer ${this.props.isManualMessage && this.props.infoTooltip ? 'numberContainerMessage' : null}`}>
          <div className="leftIcon">{this.props.isManualMessage ? cellICon : phoneIcon}</div>
          <input type={"text"}
            ref="inputTelephone"
            maxLength="15"
            className="txtDataClientCellMC"
            value={this.props.number}
            onChange={event => { this.props.onChangeNumber(event.target.value) }}
            onKeyPress={this.addingNewNumber.bind(this)}
            disabled={this.props.disabled} 
          />
          {this.props.number !== "" && <div className="cleanNumberKeyboard" onClick={this.props.onClean}>{deleteNumber}</div>}
        </div>
        {
          this.props.infoTooltip && 
          <div className='keyboard-tooltip-message'>
              <i className={`gcl-icon info`} id={'keyboard-info-tooltip'}>
                <UncontrolledTooltip placement='top' target={'keyboard-info-tooltip'} hideArrow innerClassName='keyboard-tooltip-info'>
                  {this.props.infoTooltip}
                </UncontrolledTooltip>
              </i>
          </div>
        }
        </div>
        {this.keyboard.map((item) =>
          <div key={item} ref={"key-" + item} className={`keyKeyboard ${this.props.isManualMessage && (item === '#' || item === '*') ? 'disabled' : ''}`} onClick={this.props.disabled ? '' : (this.onCreateAnimation.bind(this))}>
            <p className={`keyNumber ${this.props.isManualMessage && (item === '#' || item === '*') ? 'disabled' : ''}`} onClick={() => { this.props.disabled ? '' : (this.props.onChangeNumber(this.props.number + item))}}> {item}</p>
          </div>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/Keyboard.jsx